import * as types from './types'
import createReducer from '../../tools/createReducer'

export const token = createReducer(null, {
  [types.SET_TOKEN] (state, action) {
    return action.payload
  }
});
/** 设置userInfo为全局变量，存储在props中*/
export  const  userInfo = createReducer({},{
  setUserInfo:function(state,action){
    return action.payload;
  }
})
export const isOpenChannel = createReducer(false, {
  setIsOpenChannel: function (state,action) {
    return action.payload
  }
})

export const isDepartmentOrg = createReducer(false, {
    setIsDepartmentOrg: function (state,action) {
      return action.payload
    }
  })

  export const isMyselfSign = createReducer(false, {
    setIsMyselfSign: function (state,action) {
      return action.payload
    }
  })